// extracted by mini-css-extract-plugin
export default {"brandHeader":"_3GgAL1AeolupwbwpJr0tn_","brandBar":"_29RWIcTxbFtNqE_FgL4T1","logoSlot":"_2Y-tHO88V0B_BbLefHaTSC","companyLogo":"zMvknwbFJ3_WIXjqBHQcu"};